import styled from 'styled-components';

export const StyledCardContent = styled.div(
  {
    fontFamily: 'Poppins,sans-serif',
    textAlign: 'center',
    fontStyle: 'normal',
    lineHeight: 'normal',
    '.sub-content': {
      fontSize: '18px',
      fontWeight: 400,
      textAlign: 'center'
    }
  },
  (props) => ({
    color: props.color,
    fontSize: props.fontSize,
    fontWeight: props.fontWeight,
    '.sub-content': {
      color: props.color,
      marginTop: '11px'
    }
  })
);
